import styled from "styled-components";
import { generic } from "../../_themes/constants";

export const Label = styled.label`
  position: relative;
  display: inline-block;
  width: 100%;
  height: 0;
  padding-bottom: 38.75%;
  background: ${generic.settingToggle.background.color};
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.3s ease;
  vertical-align: middle;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  &::after {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    display: block;
    width: 58.82%;
    height: 0;
    padding-bottom: 58.82%;
    border-radius: 999px;
    background: ${generic.settingToggle.button.color};
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.05);
    content: "";
    transition: all 0.3s ease;
  }

  &:active {
    &::after {
      transform: translateY(-50%) scale(1.15, 0.85);
    }
  }
`;
